define('ordersDetailOrderProductOptionEditView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',    
  'ordersDetailOrderProductOptionEditOptionsView',
  'ordersDetailOrderProductOptionEditMixableOptionsView',  
  'template!ordersDetailOrderProductOptionEditView'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  OptionsView,
  MixableOptionsView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-detail-order-options-edit-view',   
    
    regions: {
      optionsRegion: '.options-region'  
    },

    initialize: function() {      
      if (this.model.get('optionsMix') && this.model.get('optionsMix').length > 0) {
        this.optionsView = new MixableOptionsView({
          model: this.model,
          product: this.options.product
        });       
      } else {
        this.optionsView = new OptionsView({
          model: this.model,
          product: this.options.product
        });
      }
    },

    initialized: function() {  
       this.parentView.footerView.on('add', _.bind(function () {
        console.log('Add option clicked');
        var option = new Backbone.Model({
          options: [],            
          quantity: 0
        });
        this.optionsView.collection.add(option);
        this.optionsView.scrollBottom();
      }, this));        

      this.parentView.footerView.on('confirm', _.bind(function () {
        if (this.model.get('optionsMix') && this.model.get('optionsMix').length > 0) {
          
          var data = {
            options: [],
            optionsMix: [],
            quantity: 0
          };

          _.each(this.optionsView.collection.models, _.bind(function (mo) {
            if(mo.get('quantity') > 0) {
              data.quantity += mo.get('quantity');
           
              var mixableOption = {
                options: [],
                quantity: mo.get('quantity')
              };      
            
              data.optionsMix.push(mixableOption);

              _.each(mo.get('options'), function (o) {                
                mixableOption.options.push(o.id);
              });
            }
          }, this));

          App.request('order:update-mixoptions-from-configuration', 
            this.model.get('purchaseOrderId'),
            data
          ).done(_.bind(function () {                         
            this.model.fetch();   
          }, this));

        } else {}
      }, this));
    },

    onRender: function() {  
      this.getRegion('optionsRegion').show(this.optionsView);
    }   
  });
});
